import { OUTLINE_COLOR } from "@hl/base-components/lib/theme/button";
import { STATUS_COLOR } from "@hl/base-components/lib/theme/colors";
import { WEIGHT_BOLD } from "@hl/base-components/lib/theme/typography";
import { Video } from "@hl/base-components/lib/video";
import { _CollectionType } from "@hl/shared-features/lib/apollo/graphql.generated";
import { ResizedImage } from "@hl/shared-features/lib/features/image";
import { MarketplaceToken } from "@hl/shared-features/lib/features/marketplace/utils";
import { Box, createStyles, Flex, Text, Button } from "@mantine/core";
import { Link } from "react-router-dom";

import { getDetailPageUrl } from "~/config";
import useCreatorReserves from "~/features/tokens/sections/ManageToken/modals/CreatorReserves/useCreatorReserves";

const IMAGE_FIT_SIZE = 284;

const useTokenCardStyles = createStyles((theme) => ({
  mediaItem: {
    flex: "1 1",
    border: `20px solid ${theme.colors.tableRowBackground[0]}`,
    aspectRatio: "1",
  },
  video: {
    display: "block",
    objectFit: "contain",
    width: "100%",
  },
  link: {
    textDecoration: "none",
  },
}));

const TokenCard = ({
  token,
  collection,
  collectionType,
  collectionEditionId,
}: {
  token: MarketplaceToken;
  collection: { id: string; onchainId: string };
  collectionType: _CollectionType;
  collectionEditionId: string;
}) => {
  const { cx, classes } = useTokenCardStyles();

  const { buttonLoading, buttonLabel, mint, error } = useCreatorReserves({
    collection,
    collectionType,
    collectionEditionId,
  });

  return (
    <Box pos="relative">
      <Link
        className={classes.link}
        to={getDetailPageUrl(collection, token.tokenId.toString())}
      >
        {token.animationUrl ? (
          <Video
            className={cx([classes.video, classes.mediaItem])}
            autoPlay
            loop
            muted
            playsInline
          >
            <source src={token.animationUrl} />
          </Video>
        ) : (
          <ResizedImage
            className={classes.mediaItem}
            src={token.imageUrl}
            fit="contain"
            fitSize={IMAGE_FIT_SIZE}
          />
        )}
      </Link>
      <Flex
        mt={12}
        justify="space-between"
        align="center"
        columnGap={8}
        rowGap={4}
        wrap="wrap"
      >
        <Text weight={WEIGHT_BOLD}>{token.name}</Text>
        {token.minted ? (
          <Button
            size="xs"
            color={OUTLINE_COLOR}
            style={{
              pointerEvents: "none",
            }}
          >
            Sold out
          </Button>
        ) : (
          <Box>
            <Button
              loading={buttonLoading}
              size="xs"
              onClick={() =>
                mint(1, { id: +token.tokenId, imageUrl: token.imageUrl })
              }
            >
              {buttonLabel || "Mint now"}
            </Button>
            {error && (
              <Text size="xs" mt={5} color={STATUS_COLOR.ERROR}>
                {error}
              </Text>
            )}
          </Box>
        )}
      </Flex>
    </Box>
  );
};
export default TokenCard;
